export const mixins = {
  toolbar: {
    minHeight: 80,
  },
};
